import * as React from "react";

const ErrorPage = () => {
  return (
    <section className="flex items-center h-full p-16 light:bg-gray-900 light:text-gray-100">
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <img
          src="https://yodhaprodstorage.blob.core.windows.net/yodhapublicimages/logo512.png"
          className="w-20 h-20  align-self-center mb-5"
        />
        <div className="max-w-md text-center">
          <h2 className="mb-8 font-extrabold text-9xl dark:text-gray-600">
            <span className="sr-only">Error</span>404
          </h2>
          <p className="text-2xl font-semibold md:text-3xl">
            {"Sorry, we couldn't find this page."}
          </p>
          <p className="mt-4 mb-8 dark:text-gray-400">
            Please check the organisation code, you entered.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ErrorPage;
